import * as React from "react";
import cx from "classnames";
import { SketchPicker, ColorChangeHandler } from "react-color";

interface CustomColorItemProps {
  title: string;
  color?: string;
  isPickerShowing?: boolean;
  onUpdate?: ColorChangeHandler;
  setPickerShow: (flag: boolean) => () => void;
}

const getStyles = ({ color }: CustomColorItemProps) => ({
  background: color,
});

const getClasses = ({ color }: CustomColorItemProps) =>
  cx("custom-color-item__preview", {
    empty: color === undefined,
    "not-empty": color !== undefined,
  });

const CustomColorItem = (props: CustomColorItemProps) => (
  <li className="custom-color-item">
    <div
      className={getClasses(props)}
      style={getStyles(props)}
      onClick={props.setPickerShow(true)}
    >
      {!props.color && <i className="fa fa-plus icon" />}
    </div>
    {props.isPickerShowing && (
      <div className="custom-color-item__color-picker-container">
        <SketchPicker
          disableAlpha
          color={props.color}
          onChangeComplete={props.onUpdate}
        />
        <button
          className="custom-color-item__color-picker-btn"
          onClick={props.setPickerShow(false)}
        >
          OK
        </button>
      </div>
    )}
    <p className="custom-color-item__title">{props.title}</p>
  </li>
);

export default CustomColorItem;



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/components/CustomColorItem.tsx